import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiDialogActions: Components<Theme>['MuiDialogActions'] = {
  styleOverrides: {
    root: () => ({
      justifyContent: 'center',
      padding: '0',
      '& .MuiButtonBase-root': {
        width: '100%',
      },
    }),
  },
};
